import layout from "./layout/Layout";

const themeLayout = {
  layout,
};

export default themeLayout;
